import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613 } from "@faire/web-api--source/indigofair/settings/GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613";

export const useSettingShowExpectedAddToCartAmountOnAtc = (): boolean =>
  useSetting(
    GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613,
    false
  );

export const useAssignSettingShowExpectedAddToCartAmountOnAtc = () =>
  useAssignSetting(
    GROWTH_HACK_SHOW_EXPECTED_ADD_TO_CART_AMOUNT_ON_ATC_BUTTON_250613
  );
